<fp-error [error]="error" [translateParams]="translateParams" [logoUrl]="logoUrl$ | async"></fp-error>
